export default __webpack_public_path__ + "static/care-team-cards-8055921202bcc73d46ef202cf8aa208f.svg";